{
  "actions": { "send": "Cообщить" },
  "category1": "ошибка в задании",
  "category2": "вопрос по заданию",
  "category3": "опечатка",
  "category4": "что-то не работает",
  "category5": "другая проблема",
  "error": {
    "maxFiles": "Можно прикрепить не больше {{ count }} {value, plural, one {скриншота} few {скриншотов} many {скриншотов} other {скриншотов}}",
    "send": "Не удалось отправить сообщение, попробуйте еще раз позднее"
  },
  "optionalMessage": "По желанию опишите проблему",
  "optionalMessageAndAttach": "По желанию опишите проблему и прикрепите скриншот",
  "placeholderSelect": "Выберите категорию проблемы",
  "requiredMessage": "Опишите проблему и прикрепите скриншот (по желанию)",
  "success": { "send": "Спасибо за внимательность!" },
  "title": "Сообщение об ошибке",
  "titlePrefix": "В карточке «{{ name }}»",
  "uploadFile": "Загрузите файл с компьютера"
}
